import { Box, Divider, Text } from "@wix/design-system";
import React, { useContext, useReducer, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { SliderWithInput, ToggledColorPicker } from "./../../ui-components";
import {
  BACKGROUND_COLOR_TOGGLE,
  BORDER_COLOR_TOGGLE,
  BORDER_WIDTH_INPUT,
  BORDER_WIDTH_SLIDER,
  CORNER_RADIUS_INPUT,
  CORNER_RADIUS_SLIDER,
  TEXT_COLOR_TOGGLE
} from "../dataHooks";
import classes from "../statics/styles/design-component-scss";
import { resolveColors } from "../utils/resolve-colors";
const DesignComponent = ({
  stylesData,
  config,
  onChange,
  defaultBackgroundColor,
  defaultTextColor
}) => {
  const { environment, t } = useContext(RicosContext);
  const [openedPicker, togglePicker] = useReducer(
    (prevState, picker) => {
      if (prevState === picker) {
        return null;
      }
      return picker;
    },
    null
  );
  const [userColors, setUserColors] = useState(() => ({
    textColors: resolveColors({
      colors: config.colors,
      currentColor: stylesData.colors.text ?? defaultTextColor,
      getColorFn: config.getTextColors
    }),
    borderColors: resolveColors({
      colors: config.colors,
      currentColor: stylesData.colors.border ?? defaultBackgroundColor,
      getColorFn: config.getBorderColors
    }),
    backgroundColors: resolveColors({
      colors: config.colors,
      currentColor: stylesData.colors.background ?? defaultBackgroundColor,
      getColorFn: config.getBackgroundColors
    })
  }));
  const handleOnChange = (data) => {
    onChange({
      border: { ...stylesData.border, ...data.border },
      colors: { ...stylesData.colors, ...data.colors }
    });
  };
  const showLiveSiteHint = environment !== "liveSite";
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP4", className: classes.container }, /* @__PURE__ */ React.createElement(Section, { title: t("ButtonModal_Border_Section") }, /* @__PURE__ */ React.createElement(
    SliderWithInput,
    {
      min: 0,
      max: 15,
      onChange: (width) => handleOnChange({ border: { width } }),
      label: t("ButtonModal_Width_Input"),
      sliderDataHook: BORDER_WIDTH_SLIDER,
      inputDataHook: BORDER_WIDTH_INPUT,
      value: stylesData.border.width
    }
  ), /* @__PURE__ */ React.createElement(
    SliderWithInput,
    {
      min: 0,
      max: 30,
      onChange: (radius) => handleOnChange({ border: { radius } }),
      label: t("ButtonModal_Radius_Input"),
      sliderDataHook: CORNER_RADIUS_SLIDER,
      inputDataHook: CORNER_RADIUS_INPUT,
      value: stylesData.border.radius
    }
  )), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(Section, { title: t("ButtonModal_Color_Section") }, /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, /* @__PURE__ */ React.createElement(
    ToggledColorPicker,
    {
      label: t("ButtonModal_Text_Color"),
      color: stylesData.colors.text?.toUpperCase(),
      userColors: userColors.textColors,
      onNewColorAdded: (color) => {
        config.onTextColorAdded?.(color);
        setUserColors((prev) => ({ ...prev, textColors: [...prev.textColors, color] }));
        handleOnChange({ colors: { text: color } });
      },
      onChange: (text) => handleOnChange({ colors: { text } }),
      dataHook: TEXT_COLOR_TOGGLE,
      onToggle: () => togglePicker("textColor"),
      isExpanded: openedPicker === "textColor",
      colorPickerClassName: classes.colorPicker,
      showResetButton: true,
      defaultColor: defaultTextColor,
      showLiveSiteHint
    }
  ), openedPicker === "textColor" && /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, /* @__PURE__ */ React.createElement(
    ToggledColorPicker,
    {
      label: t("ButtonModal_Border_Color"),
      color: stylesData.colors.border?.toUpperCase(),
      userColors: userColors.borderColors,
      onNewColorAdded: (color) => {
        config.onBorderColorAdded?.(color);
        setUserColors((prev) => ({ ...prev, borderColors: [...prev.borderColors, color] }));
        handleOnChange({ colors: { border: color } });
      },
      onChange: (border) => handleOnChange({ colors: { border } }),
      dataHook: BORDER_COLOR_TOGGLE,
      onToggle: () => togglePicker("borderColor"),
      isExpanded: openedPicker === "borderColor",
      colorPickerClassName: classes.colorPicker,
      showResetButton: true,
      defaultColor: defaultBackgroundColor,
      showLiveSiteHint
    }
  ), openedPicker === "borderColor" && /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, /* @__PURE__ */ React.createElement(
    ToggledColorPicker,
    {
      label: t("ButtonModal_Background_Color"),
      color: stylesData.colors.background?.toUpperCase(),
      userColors: userColors.backgroundColors,
      onNewColorAdded: (color) => {
        config.onBackgroundColorAdded?.(color);
        setUserColors((prev) => ({
          ...prev,
          backgroundColors: [...prev.backgroundColors, color]
        }));
        handleOnChange({ colors: { background: color } });
      },
      onChange: (background) => handleOnChange({ colors: { background } }),
      dataHook: BACKGROUND_COLOR_TOGGLE,
      onToggle: () => togglePicker("backgroundColor"),
      isExpanded: openedPicker === "backgroundColor",
      colorPickerClassName: classes.colorPicker,
      showResetButton: true,
      defaultColor: defaultBackgroundColor,
      showLiveSiteHint
    }
  ), openedPicker === "backgroundColor" && /* @__PURE__ */ React.createElement(Divider, null))));
};
const Section = ({ title, children }) => {
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP2" }, /* @__PURE__ */ React.createElement(Box, { paddingBottom: "SP1" }, /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "bold" }, title)), children);
};
export {
  DesignComponent
};
//# sourceMappingURL=design-component.js.map
